var exports = {
  "y": "xfb577c5e--214e78--divider",
};

module.exports = exports;
